<template>
  <div>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-empty description="您暂无测评" v-if="!info" />
      <div style="width: 100%;display: flex;align-items: center;justify-content: center;" v-if="!info">
        <el-button type="primary" @click="ceping">去测评</el-button>
      </div>
        <el-tab-pane label="MBTI职业性格测试" name="1">
          <div v-if="info">
            <el-form label-width="100px">
              <el-form-item label="你的测试类型:">
                 {{info.iden}}
              </el-form-item>
              <el-form-item label="个性特征:">
                 {{info.gexing}}
              </el-form-item>
              <el-form-item>
                 <el-button type="primary" @click="detail">查看详情</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane label="霍兰德职业兴趣测试" name="2">
          <div v-if="info">
            <el-form label-width="100px">
              <el-form-item label="你的测试类型:">
                 {{info.typeName}}
              </el-form-item>
              <el-form-item label="职业:">
                 {{info.zhiye}}
              </el-form-item>
              <el-form-item>
                 <el-button type="primary" @click="details">查看详情</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import { lookDetailCengping,lookHuolan } from "@/api/gw/ceping"
  export default {
    data(){
      return{
        info:{},
        loading:false
      }
    },
    props:{
      activeName:{
        type:String,
        default:'1'
      }
    },
    mounted(){
      this.getList();
    },
    methods:{
      detail(){
        this.$router.push({
          path:"/AppraisalmbtiResult"
        })
      },
      ceping(){
        this.$router.push({
          path:"/Appraisal"
        })
      },
      details(){
        this.$router.push({
          path:"/HollanderResult"
        })
      },
      getList(){
        if(this.activeName==1){
          this.lookDetailCengping();
        }else{
          this.lookHuolan();
        }
      },
      lookDetailCengping(){
        this.loading = true
        lookDetailCengping({}).then(res=>{
          this.info = res.data || {}
          if(res.data == null){
            this.$router.push({
              path:"/Appraisal"
            })
          }
        }).finally(()=>{
          this.loading = false
        })
      },
      lookHuolan(){
        this.loading = true
        lookHuolan({}).then(res=>{
          this.info = res.data || {}
          if(res.data == null){
            this.$router.push({
              path:"/Appraisal"
            })
          }
        }).finally(()=>{
          this.loading = false
        })
      },
      handleClick(e){
        this.getList();
      },
    },
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/home/components/ceping.vue